export { default } from './AvailablePatients';
